import { combineReducers } from '@reduxjs/toolkit'

import authReducer from './auth'
import dateReducer from './date'
import entitiesReducer from './entities'
import uiReducer from './ui'

export default combineReducers({
  auth: authReducer,
  ui: uiReducer,
  entities: entitiesReducer,
  date: dateReducer,
})
